import { LLFAbstractRenderer } from "./LLFAbstractRenderer";

/**
 * Defaultní renderer. Používá se pro renderování klasického atributu nebo
 * pokud atribut nemá jiný svůj renderer.
 */
export class LLFDefaultAttributeRenderer extends LLFAbstractRenderer {
    public canRender(_element: HTMLElement): boolean {
        return true;
    }
}
